import { DARK_TOKENS } from '../../theme/index.content';

export const TARGET_GRADIENT_TOKENS: Partial<Array<keyof typeof DARK_TOKENS>> =
  [
    'accentBackground',
    'iconGrayScale',
    'statusMemberBackground',
    'statusAmethystBackground',
    'statusTopazBackground',
    'statusAquamarineBackground',
    'statusOpalBackground',
    'statusEmeraldBackground',
    'statusRubyBackground',
    'statusSapphireBackground',
    'statusDiamondBackground',
    'statusVipBackground',
  ];
